import { defaultInstance } from '@ciam/async-utils';

export const proxyApi = {
  setAccountStatus: async ({ uid, channel }: { uid: string; channel: string }) => {
    const res = await defaultInstance.post('/setAccountStatus', { uid, channel });
    return res;
  },
  consentVersionCheck: async ({ uid, channel }: { uid: string; channel: string }) => {
    const { data } = await defaultInstance.post('/new-consent/consentVersionCheck', { uid, channel });
    return data;
  },
};
